
import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

import useTranslation from '../../../Hooks/UseTranslation'

import './ColorCodeEditor.scss'
import { SketchPicker } from 'react-color'
import InputText from './InputText'
import { addColorCode, updateColorCode } from '../../../Services/ProgrammationManagerService'
import { useProject } from '../../../Hooks/UseProject'
import { useDispatch } from 'react-redux'

interface Props {
  show: boolean
  colorCode?: any
  onHide: () => void
}

const ColorCodeEditor = ({ show, colorCode, onHide }: Props) => {

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { project } = useProject()

  const [ name, setName ] = useState('')
  const [ color, setColor ] = useState('')
  const [ saving, setSaving ] = useState(false)

  const handleSave = async () => {

    setSaving(true)

    if (!colorCode) {

      const [ error, colorCode ] = await addColorCode({ project_id: project._id, name, color })

      if (error) {

        return console.log(error)
      }

      console.log('colorCode', colorCode)

      await dispatch({ type: 'PROGRAMMATION_ADD_COLOR_CODE', payload: { colorCode } })

      setName('')
      setColor('')
    } else {
      const [ error, updatedColorCode ] = await updateColorCode({ color_id: colorCode._id, name, color })

      if (error) {

        return console.log(error)
      }

      console.log('updatedColorCode', updatedColorCode)

      await dispatch({ type: 'PROGRAMMATION_UPDATE_COLOR_CODE', payload: { colorCode: updatedColorCode } })

      setName('')
      setColor('')
    }

    setSaving(false)
    onHide()
  }

  useEffect(()=> {

    setName(colorCode?.name || '')
    setColor(colorCode?.color || '')
  }, [colorCode])

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      backdrop="static"
      keyboard={false}
      backdropClassName='color-code-editor-backdrop'
      className='color-code-editor'
    >
      <Modal.Header>
        <Modal.Title>
          {!colorCode ? t('COLOR_CODE_EDITOR:TitleAdd') : t('COLOR_CODE_EDITOR:TitleEdit')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <InputText
              value={name}
              placeholder={t('COLOR_CODE_EDITOR:InputNameLabel')}
              onChange={setName}
            />
          </Form.Group>
          <Form.Group>
            <SketchPicker
              color={color}
              onChangeComplete={(color: any) => setColor(color.hex)}
              width="calc(100% - 20px)"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={saving}
        >
          {t('COLOR_CODE_EDITOR:CancelButton')}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={saving}
        >
          {t('COLOR_CODE_EDITOR:SaveButton')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ColorCodeEditor
